import { render, staticRenderFns } from "./PollutionalertsFormHeader.vue?vue&type=template&id=434b3be6"
import script from "./PollutionalertsFormHeader.vue?vue&type=script&lang=js"
export * from "./PollutionalertsFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports